import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { TablaSectores } from "../Components/Tablas";
import { useSelector } from "react-redux";
import { BtnVolverDinamico } from "../Components/Botones";
import { ModalDinamico } from "../Components/Modals";
import { FormAddSector } from "../Components/Forms_Add";
import { useNavigate, useParams } from "react-router-dom";
import { NotFound } from "../Pages/NotFound";
import { filterData, findName } from "../globalFunctions";

export const Sectores = () => {
  const dataSectores = useSelector((state) => state.Sectores.data);
  const dataZonas = useSelector((state) => state.Zonas.data);
  const { idEm, idPl, idZo } = useParams();
  const [valueSearch, setValueSearch] = useState("");
  const [dataInit, setDataInit] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const seByZo = filterData(dataSectores, "zo_iden", parseInt(idZo));
    valueSearch === ""
      ? setDataInit(seByZo)
      : setDataInit(filterData(seByZo, "se_desc", valueSearch));
  }, [valueSearch, dataSectores, idZo]);

  return (
    <Container style={{ maxWidth: "900px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          marginTop:"5px"
        }}
      >
        <div>
          <BtnVolverDinamico
            click={() => {
              navigate(`/Empresa/${idEm}/Planta/${idPl}/Zonas`);
            }}
          />
        </div>

        <div
          style={{
            textAlign: "center",
          }}
        >
          <div
            style={{ fontStyle: "italic", textAlign: "center", padding: "5px" }}
          >
            <span>Sectores de la Zona:</span>
            <b style={{ display: "block", color: "#46be6a" }}>
              {findName(dataZonas, "zo_iden", parseInt(idZo), "zo_desc")}
            </b>
          </div>
          <ModalDinamico
            size={"sm"}
            variant={"outline-dark"}
            Body={<FormAddSector idEm={idEm} idPl={idPl} idZo={idZo} />}
            Titulo="Agregar Sector"
            nameBoton="Agregar Sector"
          />
        </div>
      </div>
      <hr />

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <span style={{ fontStyle: "italic" }}>Buscar </span>
        <input
          type="text"
          placeholder="Nombre Sector"
          onChange={(e) => {
            setValueSearch(e.target.value);
          }}
        />
      </div>

      <div>
        {dataInit.length === 0 ? (
          <NotFound textoImagen={"Ningun Sector Registrado"} />
        ) : (
          <TablaSectores data={dataInit} />
        )}
      </div>
    </Container>
  );
};
